import { Injectable } from '@angular/core';
import { Salesperson, SalespersonService } from '@vendasta/sales';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, concatMap, tap } from 'rxjs/operators';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

const SALESPEOPLE_PAGE_SIZE = 200;

@Injectable({ providedIn: 'root' })
export class SalespeopleService {
  private readonly loading$$ = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.loading$$.asObservable();

  constructor(
    private readonly salespersonService: SalespersonService,
    private readonly snackbarService: SnackbarService,
  ) {}

  // Could cause a performance hit if a partner has a lot of salespeople
  public getSalespeople(partnerId: string, marketId: string): Observable<Salesperson[]> {
    this.loading$$.next(true);
    return this.loadSalespeople(partnerId, marketId, '', []).pipe(tap(() => this.loading$$.next(false)));
  }

  private loadSalespeople(
    partnerId: string,
    marketId: string,
    cursor: string,
    salespeople: Salesperson[],
  ): Observable<Salesperson[]> {
    return this.salespersonService
      .listSalespersons({ partnerId: partnerId, marketId: marketId }, cursor, SALESPEOPLE_PAGE_SIZE)
      .pipe(
        concatMap((response) => {
          salespeople.push(...response.results);

          if (response.nextCursor) {
            return this.loadSalespeople(partnerId, marketId, response.nextCursor, salespeople);
          } else {
            return of(salespeople);
          }
        }),
        catchError(() => {
          this.snackbarService.openErrorSnack('MANAGE_ACCOUNTS.ERROR_LOADING_SALESPEOPLE');
          return of([]);
        }),
      );
  }
}
